import React from 'react'

import ContentHeader from "@components/modules/content-header/"

class SearchResultsHeaderTitle extends React.Component {
    render() {
        return (
            <ContentHeader
                sectionContainerClass=""
                Title={this.props.Title}
                titleClass={this.props.titleClass}
                pageName_1="Jobs"
                pageLink_1="#"
                lastClass_1="last"
            />
        )
    }
}

export default SearchResultsHeaderTitle